'use strict'

var chunkedSplice = require('./chunked-splice.js')

function chunkedPush(list, items) {
  if (list.length) {
    chunkedSplice(list, list.length, 0, items)
    return list
  }

  return items
}

module.exports = chunkedPush



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/util/chunked-push.js
// module id = 436
// module chunks = 0